import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import Order from './Order'

function OrderContainer() {
  const [navParams, setNavParams] = useState({
    navTitle: "All",
    navSubTitle: "Welcome to ImagesBazaar"
  })


  const handleNavParams = (obj) => {
    setNavParams({
      ...navParams,
      ...obj
    })
  }

  return (
    <MainLayout navTitle={navParams.navTitle} navSubTitle={navParams.navSubTitle}>
      <Order handleNavParams={handleNavParams} />
    </MainLayout>
  )
}

export default OrderContainer